// Types of Drawer Headers
export enum DrawerHeaderType {
  // close button on the right
  Close = 'close',
  // back button on the left
  Back = 'back',
}
